import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth, postAuthDestination } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
/**
 * Handles `/auth/google?code=...&state=...` — exchanges the code with the
 * backend and routes the user to their dashboard (or the original `next` path).
 */
export default function GoogleOAuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        const err = params.get("error");
        if (err) {
          navigate("/login?error=" + encodeURIComponent(err));
          return;
        }
        if (!code) {
          navigate("/login");
          return;
        }
        const role = sessionStorage.getItem("kb_onboarding_role") || "client";
        const next = sessionStorage.getItem("kb_oauth_next");
        const redirect_uri = window.location.origin + "/auth/google";
        const res = await api.post("/auth/google/callback", { code, redirect_uri, role });
        if (res.data.session_token) localStorage.setItem("kb_session_token", res.data.session_token);
        setUser(res.data.user);
        sessionStorage.removeItem("kb_onboarding_role");
        sessionStorage.removeItem("kb_oauth_next");
        const dest = next || postAuthDestination(res.data.user);
        window.history.replaceState({}, "", dest);
        navigate(dest, { replace: true });
      } catch (e) {
        console.error("Google OAuth callback failed", e);
        navigate("/login?error=auth_failed");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-kb-bg" data-testid="google-oauth-callback-page">
      <div className="text-center">
        <div className="kb-mono text-xs uppercase tracking-[0.2em] text-kb-ink-muted mb-3">Authenticating</div>
        <div className="font-serif text-2xl text-kb-ink">Connecting your KhojByte workspace…</div>
        <div className="mt-6 mx-auto w-24 h-1 bg-slate-200 rounded-full overflow-hidden">
          <div className="h-full w-1/2 bg-kb-primary animate-pulse" />
        </div>
      </div>
    </div>
  );
}
